export const categoryArray = [
    {
     category:"All",
     url_pram:"geography,arts_and_literature,film_and_tv,food_and_drink,general_knowledge,history,music,science,society_and_culture,sport_and_leisure"  
    },
    {
     category:"Arts & Literature",
     url_pram:"arts_and_literature"   
    },
    {
     category:"Film & TV",
     url_pram:"film_and_tv"   
    },
    {
     category:"Food & Drink",
     url_pram:"food_and_drink"   
    },
    {
     category:"Geography",
     url_pram:"geography"   
    },
    {
     category:"History",
     url_pram:"history"   
    },
     {
     category:"Science",
     url_pram:"science"   
    },
     {
     category:"Music",
     url_pram:"music"   
    },
     {
     category:"Society & Culture",
     url_pram:"society_and_culture"   
    },
     {
     category:"Sport & Leisure",
     url_pram:"sport_and_leisure"   
    }

]
export const successText = [
  "You do the most!",
  "You should be proud of yourself",
  "Oshey! king of doings",
  "You rock!",
  "That's it",
  "After you na you, boss"
]
export const failureText = [
  "You'll get it next time",
  "At least you know you're not right",
  "Don't feel bad",
  "That is wrong",
  "Oops you got it wrong",
  "You can do better"
]

  export const difficultyArray = [
    "easy", "medium","hard"
  ]
